<template>
  <v-card max-height="706px">
    <v-container style="padding: 32px 40px;">
      <v-row>
        <v-col cols="11">
          <h4 style="font-weight:bold;">ブックマーク選択</h4>
        </v-col>
        <v-col cols="1">
          <IconButton iconStr="mdi-close" :event="modalClose" />
        </v-col>
      </v-row>
      <v-row v-show="isNotDuplicate">
        <v-col cols="12">
          <v-alert
            dense outlined type="error"
            v-model="isNotDuplicate"
          >重複しているurlは除外されました
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-show="isNotSafetyUrlOnly">
        <v-col cols="12">
          <v-alert
            dense outlined type="error" 
            v-model="isNotSafetyUrlOnly"
          >http、https以外のurlは除外されました
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="scroll-bookmark">
            <BookmarkSelectTable :bookmarkList="bookmarkList" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <EventButton 
            buttonName="戻る" :event="clickBack"
          />
        </v-col>
        <v-col cols="5">
        </v-col>
        <v-col cols="5">
          <EventButton 
            buttonName="トピックパーツに反映" :event="applyTopicParts"
            :isDisabled="checkTopic" :isLoading="isLoading"
            style="font-size: 16px; padding: 9px 30px; margin-left: -5px;"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
  import EventButton from '../atoms/EventButton.vue';
  import BookmarkSelectTable from '../molecules/BookmarkSelectTable.vue';
  import IconButton from '../atoms/IconButton.vue';
  export default {
    name: 'BookmarkSelectForm',
    data() {
      return {
        bookmarkList: '',
        isDuplicate: false,
        isNotSafetyUrlOnly: false,
        checkTopic: true,
        isLoading: false
      }
    },
    props: [
      'changeModalState',
      'addInput',
      'isCloseBookmarkModal',
      'topic'
    ],
    components: {
      EventButton,
      BookmarkSelectTable,
      IconButton
    },
    computed: {
      topicCount() {
        return this.$store.getters['bookmark/topicCount'];
      },
    },
    methods: {
      applyTopicParts() {
        this.isLoading = true;
        if (this.createTopicParts()) {
          this.isLoading = false;
          this.resetAll();
          this.changeModalState(0);
          return this.isCloseBookmarkModal();
        }
        return console.log('create error');
      },
      topicValidate(topicCount) {
        // topicの数が0だったらbuttonを非活性
        if (topicCount === 0) {
          return this.checkTopic = true
        }
        // topicの数が100以上だったらbuttonを非活性
        if (topicCount > 100) {
          return this.checkTopic = true
        }
        // topicの数が0以上100未満だったらbuttonを活性
        if (topicCount > 0 && topicCount <= 100) {
          return this.checkTopic = false
        }
      },
      clickBack() {
        this.resetAll()
        this.changeModalState(0);
      },
      createTopicParts() {
        // storeにtopicPartsが存在したらトピックパーツを生成する
        if (this.$store.getters['bookmark/topicCount'] !== 0) {
          const bookmarkList = this.$store.getters['bookmark/topicParts'];
          for(var key in bookmarkList) {
            this.addInput(bookmarkList[key].name, bookmarkList[key].url)
          }
        }
        return true;
      },
      resetAll() {
        // store/bookmarkを初期化
        this.$store.dispatch('bookmark/resetState');
        this.bookmarkList = '';
        this.isDuplicate = false;
        this.isNotSafetyUrlOnly = false;
        this.checkTopic = true;
        this.isLoading = false;
      },
      modalClose() {
        if (confirm('トピックに反映されておりませんがモーダルを閉じてよろしいですか？')) {
          this.resetAll();
          this.changeModalState(0);
          this.isCloseBookmarkModal();
          return;
        } else {
          return;
        }
      },
    },
    created: function() {
      // storeにbookmarkListがない場合はbookmark_uploadにリダイレクトする
      if (!this.$store.getters['bookmark/bookmarkList'].length) {
        this.changeModalState(0);
      }
      this.bookmarkList = this.$store.getters['bookmark/bookmarkList'];
      this.isNotDuplicate = !this.$store.getters['bookmark/isNotDuplicate'];
      this.isSafetyUrlOnly = !this.$store.getters['bookmark/isSafetyUrlOnly'];
    },
    // stateに保存されているtopicPartsの数を監視してバリデートをかけている
    watch: {
      topicCount(val) {
        this.topicValidate(val);
      }
    }
  }
</script>
<style scoped>
  .scroll-bookmark{
    height: 434px;
    overflow-y: scroll; 
  }
</style>